import { useContext } from 'react'

import SearchOrPOISummaryCard from '../SummaryCards/Search/SearchOrPOISummaryCard'

import ExploreCardSkeleton from 'tripPlanner/components/Skeleton/ExploreCardSkeleton'
import type { ExploreItem, ItemWithOnlyLatLng } from 'tripPlanner/types/common'
import { isExploreItem } from 'tripPlanner/utils/explore'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'

interface Props {
  selectedMarker: ExploreItem | ItemWithOnlyLatLng | undefined | null
}

function GooglePOICardSingle({
  selectedMarker,
}: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  return (
    <>
      {selectedMarker && isExploreItem(selectedMarker) && (
        <SearchOrPOISummaryCard
          item={selectedMarker}
          showCloseButton
          onClose={onDeselectMapItem}
        />
      )}
      {!(selectedMarker && isExploreItem(selectedMarker)) && (
        <ExploreCardSkeleton />
      )}
    </>
  )
}

export default GooglePOICardSingle
